import React from 'react'
import AnnouncementContainer from '@/src/components/announcements'
import { useStore } from '@/src/types/store'
import { Box, CircularProgress } from '@mui/material'

const Dashboard = () => {
  const { themeLoading } = useStore()
  if (themeLoading) {
    return (
      <Box className="h-screen w-full flex justify-center items-center">
        <CircularProgress size={30} />
      </Box>
    )
  } else {
    return <AnnouncementContainer category="dashboard" />
  }
}

export default Dashboard
